import { GAME_ID, REDUX_ACTIONS, SPEAKER_STATES } from 'a/wordSlide/data/constants';

const initialState = SPEAKER_STATES.INACTIVE;

const speakerReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_SPEAKER_STATE:
      return payload;

    default:
      return state;
  }
};

export default speakerReducer;
